import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/saga-blue/theme.css";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { confirmDialog } from "primereact/confirmdialog";
import { useDispatch, useSelector } from "react-redux";
import {
  addEmptyFamily,
  removeFamily,
  setFamilyError,
  setFamilyValue,
  setRelativeTypeList,
} from "../../redux/familySlice";
import apiService from "../service/apiService";
import { SaveButton } from "./declerationDetails";
import { NextButton, PrevButton } from "./kycSidebar";
import { DynamicFieldSection } from "./personalDetails";
import { getTValue } from "../other/label";
import InputText from "../other/InputText";
import { validateNameField, validateNepaliNameField } from "../../helper/validationHelper";

const rlist = [
  {
    id: 1,
    descEng: "Grand Fathers",
    descNep: "वाजेको नाम",
  },
  {
    id: 2,
    descEng: "Fathers",
    descNep: "बुबाको नाम",
  },
  {
    id: 3,
    descEng: "Mothers",
    descNep: "आमाको नाम",
  },
  {
    id: 4,
    descEng: "Spouse",
    descNep: "पति/पत्नीको नाम",
  },
  {
    id: 5,
    descEng: "Sons",
    descNep: "छोराको नाम",
  },
  {
    id: 6,
    descEng: "Daughters",
    descNep: "छोरीको नाम (अविवाहित)",
  },
  {
    id: 7,
    descEng: "Daughters in-Law",
    descNep: "बुहारीको नाम",
  },
  {
    id: 8,
    descEng: "Fathers in-Law",
    descNep: "ससुराको नाम (विवाहित महिलाको हकमा)",
  },
  {
    id: 9,
    descEng: "Mothers in-Law",
    descNep: "सासुको नाम(विवाहित महिलाको हकमा)",
  },
];

const footer = () => (
  <div class=" p-field p-col-12 p-md-12">
    <div className="p-grid" style={{ flex: 3, padding: "0 10px" }}>
      <div style={{ flex: 1 }}>
        <PrevButton />
      </div>
      <div style={{ flex: 1 }}>
        <center>
          <SaveButton show={true} style={{ flex: 1 }} />
        </center>
      </div>
      <div style={{ flex: 1 }}>
        <center>
          <NextButton />
        </center>
      </div>
    </div>
  </div>
  // <div className="p-grid">
  //   <div className="p-col-12 p-md-5">
  //     <PrevButton />
  //   </div>
  //   <div className="p-col-12 p-md-2">
  //     <SaveButton />
  //   </div>
  //   <div className="p-col-12 p-md-3"></div>
  //   <div className="p-col-12 p-md-2">
  //     <NextButton />
  //   </div>
  // </div>
);

function FamilyDetails() {
  const { t, i18n } = useTranslation();
  const relativeTypeList = useSelector(
    (state) => state.familyDetails.relativeTypeList
  );
  const relativeList = useSelector((state) => state.familyDetails.relativeList);
  const maritalStatus = useSelector((state) => state.personalDetails.maritalStatus);
  // const familyDetailsError = useSelector(
  //   (state) => state.familyDetails.familyDetailsError
  // );
  let familyDetailsError = "";
  const errorObj = useSelector((state) => state.familyDetails.errors);
  if (errorObj && errorObj.familyDetailsError) {
    familyDetailsError = errorObj.familyDetailsError.message;
  }

  const dispatch = useDispatch();

  const [relationData, setRelationData] = useState();

  useEffect(() => {
    if (!relativeTypeList.length)
      apiService.getRelationTypeList().then((response) => {
        let relationDataList = response.data.data.filter(
          (p) => p.isMultiple === true
        );
        setRelationData(relationDataList);
        let tempRelationDataList = response.data.data.filter(
          (p) => p.isFor === null
        );
        dispatch(
          setRelativeTypeList(
            tempRelationDataList.length ? tempRelationDataList : rlist
          )
        );
      });
  }, []);

  const getFormErrorMessage = (name) => {
    return (
      errorObj[name] && <small className="p-error">{errorObj[name]}</small>
    );
  };
  return (
    <Card
      className="p-col-12 p-md-12 main-card"
      header={() => (
        <h3 className="p-col-12 p-md-12 text-center">
          <i className="pi pi-user" /> {t("familyDetails")}
        </h3>
      )}
      footer={footer}
    >
      <div className="p-grid p-fluid p-col-12 p-md-12" style={{ margin: 0 }}>
        <div className="p-field p-col-12 p-md-12">
          <h5 style={{ color: 'red', padding: '3px' }}>
            {t("familyInfoMsg")}
          </h5>
          {relativeList
            .map((relation, i) => relation.relativeType && (!relation.relativeType.maritalStatus || relation.relativeType.maritalStatus === maritalStatus) ? (
              <div key={"relation" + i} className="p-grid p-fluid">
                <label className="p-grid p-col-12 p-md-12" style={{ margin: 0 }}>
                  <h4 className="p-col-12 p-md-10">
                    <p className="section-title">
                      {relation.relativeType &&
                        getTValue(
                          i18n,
                          relation.relativeType.descEng,
                          relation.relativeType.descNep
                        )}
                    </p>
                    {errorObj[relation.relativeTypeId + "FamilyError"] && (
                      <span style={{ color: "red", fontWeight: "normal" }}>
                        {
                          errorObj[relation.relativeTypeId + "FamilyError"]
                            .message
                        }
                      </span>
                    )}
                  </h4>
                </label>
                <div className="p-field p-col-12 p-md-12">
                  <label className="p-col-12 p-md-12" htmlFor="nameEng">
                    {t("nameEnglish")}
                  </label>
                  <div className="p-inputgroup">
                    <InputText
                      placeholder={t("fName")}
                      isName
                      keyfilter="alpha"
                      onChange={(e) =>
                        dispatch(
                          setFamilyValue({
                            index: i,
                            key: "firstName",
                            value: e.target.value,
                          })
                        )
                      }

                      onBlur={(e) => {
                        // Use dynamic validation helper for firstName
                        validateNameField(e.target.value, "First Name", dispatch, setFamilyError, setFamilyError, { key: i + "1", relationTypeDesc: relation.relationTypeDesc }, "Valid First Name is required");
                      }}
                      value={relation.firstName}
                    />

                    <InputText
                      placeholder={t("mName")}
                      isName
                      keyfilter={/^[a-zA-Z ]*$/}
                      onChange={(e) =>
                        dispatch(
                          setFamilyValue({
                            index: i,
                            key: "middleName",
                            value: e.target.value,
                          })
                        )
                      }
                      value={relation.middleName}
                    />
                    <InputText
                      placeholder={t("lName")}
                      isName
                      keyfilter={/^[a-zA-Z .]*$/}
                      onChange={(e) =>
                        dispatch(
                          setFamilyValue({
                            index: i,
                            key: "lastName",
                            value: e.target.value,
                          })
                        )
                      }
                      onBlur={(e) => {
                        // Use dynamic validation helper for firstName
                        validateNameField(e.target.value, "Last Name", dispatch, setFamilyError, setFamilyError, { key: i + "3", relationTypeDesc: relation.relationTypeDesc }, "Valid Last Name is required");
                      }}
                      value={relation.lastName}
                    />
                  </div>
                </div>

                <span style={{ color: "red" }}>{errorObj["FamilyError" + i + "1"] && errorObj["FamilyError" + i + "1"]}</span>
                {/* {firstNameError && lastNameError && <br />} */}
                <span style={{ color: "red", marginLeft: "25%" }}>{errorObj["FamilyError" + i + "3"] && errorObj["FamilyError" + i + "3"]}</span>
                <div className="p-field p-col-12 p-md-12">
                  <label className="p-col-12 p-md-12" htmlFor="nameNep">
                    {t("nameNepali")}
                  </label>
                  <div className="p-inputgroup">
                    <InputText
                      placeholder={t("fNameNep")}
                      keyfilter="alpha"
                      isName
                      convertToNepali
                      onChange={(e) => {
                        dispatch(
                          setFamilyValue({
                            index: i,
                            key: "firstNameNep",
                            value: e.value,
                          })
                        );
                        validateNepaliNameField(e.target.value, "First Name", dispatch, setFamilyError, setFamilyError, { key: i + "1" + "Nep", relationTypeDesc: relation.relationTypeDesc }, "Valid Nepali First Name is required");

                      }}
                      onBlur={(e) => {
                        // Use dynamic validation helper for firstName
                      }}
                      value={relation.firstNameNep}
                    />
                    <InputText
                      placeholder={t("mNameNep")}
                      isName
                      convertToNepali
                      keyfilter={/^[a-zA-Z ]*$/}
                      onChange={(e) => {
                        dispatch(
                          setFamilyValue({
                            index: i,
                            key: "middleNameNep",
                            value: e.value,
                          })
                        );
                      }}
                      value={relation.middleNameNep}
                    />
                    <InputText
                      placeholder={t("lNameNep")}
                      keyfilter="alpha"
                      isName
                      convertToNepali
                      onChange={(e) => {
                        dispatch(
                          setFamilyValue({
                            index: i,
                            key: "lastNameNep",
                            value: e.value,
                          })
                        );
                        validateNepaliNameField(e.target.value, "Last Name", dispatch, setFamilyError, setFamilyError, { key: i + "3" + "Nep", relationTypeDesc: relation.relationTypeDesc }, "Valid Nepali Last Name is required");

                      }}
                      value={relation.lastNameNep}
                    />
                  </div>
                </div>

                <span style={{ color: "red" }}>{errorObj["FamilyError" + i + "1" + "Nep"] && errorObj["FamilyError" + i + "1" + "Nep"]}</span>
                {/* {firstNameError && lastNameError && <br />} */}
                <span style={{ color: "red", marginLeft: "52%" }}>{errorObj["FamilyError" + i + "3" + "Nep"] && errorObj["FamilyError" + i + "3" + "Nep"]}</span>

                {relation.relativeType && relation.relativeType.isMultiple && (
                  <div className="p-field p-col-12 p-md-12">
                    <Button
                      style={{ textAlign: "center", float: "right" }}
                      className="add-button"
                      icon="pi pi-plus"
                      onClick={() =>
                        dispatch(addEmptyFamily(relation.relativeTypeId))
                      }
                      label="Add"
                    />
                    <Button
                      style={{ textAlign: "center", float: "right" }}
                      className="add-button pi-button-secondary"
                      label="Remove"
                      onClick={() => {
                        confirmDialog({
                          message: "Are you sure you want to delete?",
                          header: "Confirmation",
                          icon: "pi pi-exclamation-triangle",
                          accept: () => dispatch(removeFamily(i)),
                        });
                      }}
                    />
                  </div>
                )}
              </div>
            ) : null)}
        </div>
        <DynamicFieldSection />
      </div>
    </Card>
  );
}

export default FamilyDetails;
